import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

import { TColorKeys } from 'theme/palette';
import { withSxProp } from 'common/utils/props';

interface IProps {
    color: TColorKeys;
    size?: number;
    children?: React.ReactNode;
    sx?: SxProps<Theme>;
}

/**
 * A small colored status indicator dot, optionally followed by a label.
 */
export const StatusDot = ({ color, size = 10, children, sx }: IProps) => (
    <Box
        sx={[
            {
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle',
                gap: 1,
            },
            ...withSxProp(sx),
        ]}
    >
        <Box
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                borderRadius: '50%',
                bgcolor: `${color}.main`,
            }}
        />

        {children}
    </Box>
);
